import React from "react";
// import Title from "antd/lib/typography/Title";
// import Paragraph from "antd/lib/typography/Paragraph";
// import colors from "constants/colors";
import { StyledTitleDiv, StyledTextDiv, StyledCard, StyledTextDivBold } from "./style";

const BookingInfoCard = () => {
  return (
    <>
      <StyledCard>
        <StyledTitleDiv>Informasjon om booking og pris</StyledTitleDiv>
        <StyledTextDivBold>Hva koster en bedriftspresentasjon med Bindeleddet?</StyledTextDivBold>
        <StyledTextDiv>
          Informasjon om priser finner dere i bookingkalenderen etter at bookingen er åpnet.
        </StyledTextDiv>
        <StyledTextDivBold>Når kan vi arrangere bedriftspresentasjon?</StyledTextDivBold>
        <StyledTextDiv>
          Bedriftspresentasjonssesongen for høsten 2021 varer fra uke 35 til og med uke 43, med unntak av uke 37 pga.
          KarriereDagene NTNU og andre utvalgte datoer.
        </StyledTextDiv>
        <StyledTextDivBold>Hvilken ukedag bør vi velge?</StyledTextDivBold>
        <StyledTextDiv>
          Av erfaring er mandag, tirsdag og onsdag passende for mellomstore presentasjoner for mellom 20 og 60
          studenter, mens torsdag og fredag er passende for større presentasjoner. På fredager vil selve presentasjonen
          vare fra 12:15-13:00, og fra 17:15-18:00 øvrige ukedager. På torsdager pleier mange studenter å dra ut på
          byen, derfor velger mange bedrifter å ha alkoholservering som en del av bespisningen. Det er flere måter å
          gjøre dette på også, litt avhengig av hvor bespisningen holdes. Spør oss gjerne om tips for hvilken dag som
          passer deres opplegg best.
        </StyledTextDiv>
        <StyledTextDivBold>Hva er inkludert når vi booker en bedriftspresentasjon?</StyledTextDivBold>
        <StyledTextDiv>
          <ul>
            <li>Bestilling av egnede lokaler til presentasjon og bespisning.</li>
            <li>Bistand i planlegging av presentasjon og sosialt opplegg.</li>
            <li>Markedsføring av presentasjonen gjennom plakater og websider.</li>
            <li>Kvalitetssikring av det tekniske opplegget.</li>
            <li>Webbasert påmeldingssystem med mulighet for å sette av plasser for ønskede linjer og klassetrinn.</li>
            <li>Statistikk over påmeldte studenter.</li>
            <li>Stand sentralt på campus.</li>
            <li>Skriftlig tilbakemelding om bedriftens presentasjon.</li>
            <li>Hvor mye koster det å arrangere en bedriftspresentasjon?</li>
            <li>
              Informasjon om priser finner dere i bookingkalenderen på neste side. Bespisning vil komme utenom, og vil
              avhenge av sted for bespisningen og antall studenter som deltar på presentasjonen. Vi er behjelpelige med
              å finne et passende sted for deres bedrift.
            </li>
          </ul>
        </StyledTextDiv>
        <StyledTextDivBold>Hvilket opplegg bør vi gjennomføre?</StyledTextDivBold>
        <StyledTextDiv>
          Ved booking av bedriftspresentasjon vil vi hjelpe til med å planlegge arrangementet i samarbeid med dere.
          Presentasjon vil kanskje måtte holdes enten digitalt eller på et egnet sted utenfor campusområdet. Ved valg av
          sistnevnte er vi gjerne behjelpelige med å finne egnet sted for både presentasjon og bespisning
        </StyledTextDiv>
        <StyledTextDiv>
          Hvis forholdene tilater: Bespisningen kan enten være på campus, i Kjelkantinen, eller holdes på en restaurant
          i Trondheim. Det er også mulig å avholde selve presentasjonen eksternt på samme sted som bespisningen. På
          dagtid kan dere stå på stand eller gjennomføre arrangementer som intervjuer, mingling eller case.
        </StyledTextDiv>
        <StyledTextDivBold>Hvilke studenter når vi ut til?</StyledTextDivBold>
        <StyledTextDiv>
          Bindeleddet NTNU er bedriftskontakten for Indøk, men vi samarbeider tett med de andre linjeforeningene på
          Gløshaugen. Å åpne presentasjonen for andre linjer gjør vi gledelig, men vi har et krav om at minst halvparten
          av plassene skal være reservert for indøkstudenter. Markedsføring mot de andre linjene utover informasjon i
          arrangementet på våre egne nettsider kan gjøres mot et gebyr til den respektive linjeforening.
        </StyledTextDiv>
      </StyledCard>
    </>
  );
};

export default BookingInfoCard;
